import BusinessUnitRole from 'components/commercetools-ui/business-unit/role';
import { useAccount } from 'helpers/hooks/useAccount';
import { useFormat } from 'helpers/hooks/useFormat';
import { TranslateIcon } from '@heroicons/react/solid';
import React, { useEffect } from 'react';
import AccountButton from 'bic/components/commercetools-ui/header/account-button';
import NotificationButton from 'components/commercetools-ui/notifications/notification-button';
import { useNotifications } from 'frontastic/provider/Notifications';
import { useRouter } from 'next/router';

type Props = {
  data: any;
};

const BicUserBarTastic: React.FC<Props> = ({ data }) => {
  const { account } = useAccount();
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });
  const { setToken } = useNotifications();
  const router = useRouter();

  const organization = data.organization?.dataSource?.organization;
  const notificationToken = data.notifications?.dataSource?.notificationToken;

  useEffect(() => {
    if (notificationToken) {
      setToken(notificationToken);
    }
  }, []);

  return (
    <div className={`relative flex h-full flex-row items-center justify-end py-4 pr-2 md:py-3 ${data.bgColor}`}>
      <>
        <AccountButton
          account={account}
          accountLink={data.accountLink}
          organization={organization}
          businessUnitLink={data.businessUnitLink}
        />
        <div className="ml-2">
          {formatAccountMessage({ id: 'welcome', defaultMessage: 'Welcome' }) +
            ', ' +
            (account?.firstName ?? account?.lastName ?? 'User')}
        </div>
        {/* <BusinessUnitRole organization={data.organization?.dataSource?.organization} /> */}
        <NotificationButton className="ml-2" />
      </>
    </div>
  );
};

export default BicUserBarTastic;
